import React from "react";
import { Switch, Route } from "react-router-dom";

import VendorsPage from "./VendorsPage";
import VendorPage from "./VendorPage";

const Vendors = () => (
  <Switch>
    <Route path="/fleet/vendors/:id">
      <VendorPage />
    </Route>
    <Route path="/fleet/vendors">
      <VendorsPage />
    </Route>
  </Switch>
);

export default Vendors;
